import React, { Suspense, ComponentType } from 'react'
import { Loader2 } from 'lucide-react'

// Loading component for lazy-loaded routes
const RouteLoader = () => (
  <div className="flex w-full items-center justify-center min-h-[40vh]">
    <div className="flex flex-col items-center gap-4">
      <Loader2 className="h-8 w-8 animate-spin text-blue-600" />
      <p className="text-sm text-gray-600">Loading...</p>
    </div>
  </div>
)

// Utility function to create lazy-loaded components with error boundary
export const lazyImport = <T extends ComponentType<any>>(
  importFunc: () => Promise<{ default: T }>
) => {
  const LazyComponent = React.lazy(importFunc)
  
  return (props: React.ComponentProps<T>) => (
    <Suspense fallback={<RouteLoader />}>
      <LazyComponent {...props} />
    </Suspense>
  )
}

// Alternative with custom loading component
export const lazyImportWithLoader = <T extends ComponentType<any>>(
  importFunc: () => Promise<{ default: T }>,
  LoaderComponent?: ComponentType
) => {
  const LazyComponent = React.lazy(importFunc)
  const Loader = LoaderComponent || RouteLoader
  
  return (props: React.ComponentProps<T>) => (
    <Suspense fallback={<Loader />}>
      <LazyComponent {...props} />
    </Suspense>
  )
}
